<script setup>
import { ref } from 'vue';
import { __ } from '@/utils';
 
const MINUTES = 5;

const emit = defineEmits(['loader'])
const { msisdn, loader, action, payload } = defineProps({
    msisdn: String,
    loader: Boolean,
    action: {
        type: String,
        default: 'send_otp_code',
    },
    payload: {
        type: Object,
        default: () => ({}),
    },
});

const timer = ref(localStorage.getItem('otpTimer') || null);
const interval = ref(null);
const currentTimer = ref(null);

const setTimer = () => {
    const now = new Date();
    const fiveMinutesLater = new Date(now.getTime() + MINUTES * 60000);
    timer.value = fiveMinutesLater;
    localStorage.setItem('otpTimer', fiveMinutesLater);
}

const timerCountDown = () => {
    if(!localStorage.getItem('otpTimer')) {
        return;
    }
    const now = new Date();
    const timerValue = new Date(timer.value);
    const diff = timerValue - now;
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    if (diff < 0) {
        localStorage.removeItem('otpTimer');
        clearInterval(interval.value);
        currentTimer.value = null;
        return '00:00';
    }

    currentTimer.value = `${minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
}

const initTimer = () => {
    if (timer.value) {
        timerCountDown();
        interval.value = setInterval(() => {
            timerCountDown();
        }, 1000);
    }
}
const sendOTP = () => {
    emit('loader', true)

    const requestPayload = Object.keys(payload || {}).length
        ? payload
        : {
            OTP: msisdn,
        };

    const sanitizedPayload = Object.fromEntries(
        Object.entries(requestPayload || {}).filter(([, value]) => value !== undefined && value !== null && value !== '')
    );

    const body = new URLSearchParams({
        action,
        ...sanitizedPayload,
    }).toString();

	fetch(ajax_object.ajax_url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
        body,
	})
		.then(response => response.json())
		.then(data => {
			if (data.success) {
				const responseData = JSON.parse(data.data)
			}
		})
		.catch(error => console.error('Error:', error))
        .finally(() => {
            setTimer();
            initTimer();
            emit('loader', false)
        });
}

if(timer.value) {
    initTimer();
}
</script>
<template>
    <p>
        {{ __("Didn't receive a code?") }}
    
        <button class="link-underline" @click="sendOTP" type="button" :disabled="loader || currentTimer">
            {{ __('Click here to send it again') }} 
            <template v-if="currentTimer">
                <small>{{ currentTimer }}</small>
            </template>
        </button>
    </p>
</template>